import React from 'react'
import { useI18n } from 'i18n'

export const MIN_PASSWORD = 10

// 0–3: length plus character variety. Only a hint; the API enforces the minimum.
const passwordScore = (value) => {
  if (value.length < MIN_PASSWORD) return value ? 1 : 0
  const kinds = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/].filter((re) => re.test(value)).length
  return kinds >= 3 || value.length >= 16 ? 3 : 2
}
const SCORE_TONE = ['bg-slate-200', 'bg-status-failed', 'bg-status-review', 'bg-status-ready']
const SCORE_LABEL = ['', 'signup.passwordWeak', 'signup.passwordOk', 'signup.passwordStrong']

// Three-segment meter + hint under a new-password field (`id` for aria-describedby).
const PasswordStrength = ({ id, value }) => {
  const { t } = useI18n()
  const score = passwordScore(value)
  return (
    <>
      <div className='mt-2 flex items-center gap-2' aria-hidden>
        {[1, 2, 3].map((i) => (
          <span key={i} className={`h-1 flex-1 rounded-full transition-colors ${score >= i ? SCORE_TONE[score] : 'bg-slate-200'}`} />
        ))}
      </div>
      <p id={id} className='mb-5 mt-1 text-xs text-slate-500'>
        {score ? t(SCORE_LABEL[score]) : t('signup.passwordHint', { min: MIN_PASSWORD })}
      </p>
    </>
  )
}

export default PasswordStrength
